export const ALL_OPTION = "All";
export const UNASSIGNED_OPTION = "Unassigned";

// Option values are prefixed so a speciality that happens to be called "Unassigned"
// cannot collide with the Unassigned entry.
export const SPECIALITY_MENU_PREFIX = "assign-speciality:";
export const UNASSIGNED_MENU_KEY = "assign-unassigned";

export const filterReferralBySpecialities = (referrals, specialities) => {
  if (specialities.includes(ALL_OPTION)) {
    return referrals;
  }
  const selectedReferrals = referrals.filter(({ specialityName }) => specialities.includes(specialityName));
  return specialities.includes(UNASSIGNED_OPTION)
    ? selectedReferrals.concat(referrals.filter(({ specialityName }) => !specialityName))
    : selectedReferrals;
};

/**
 * Counts every referral, never the filtered view — a folder's count is its own size, not
 * the size of whatever the filter currently shows. `unknown` holds non-empty names that
 * are not in specialityNames (an old AI guess, or a speciality since renamed or deleted);
 * they are deliberately not folded into `unassigned`.
 */
export const countReferralsByFolder = (referrals = [], specialityNames = []) => {
  const known = new Set(specialityNames);
  const byName = {};
  specialityNames.forEach((name) => {
    byName[name] = 0;
  });

  let unassigned = 0;
  let unknown = 0;
  referrals.forEach(({ specialityName }) => {
    if (!specialityName) {
      unassigned += 1;
    } else if (known.has(specialityName)) {
      byName[specialityName] += 1;
    } else {
      unknown += 1;
    }
  });

  return { total: referrals.length, unassigned, unknown, byName };
};

/** Counts go in the label only: the select is controlled by value, so the selection
 *  survives a recount. */
export const buildSpecialityFilterOptions = (specialityNames = [], referrals = []) => {
  const { total, unassigned, byName } = countReferralsByFolder(referrals, specialityNames);
  return [
    { label: `${ALL_OPTION} (${total})`, value: ALL_OPTION },
    ...specialityNames.map((name) => ({
      label: `${name} (${byName[name]})`,
      value: name,
    })),
    {
      label: `${UNASSIGNED_OPTION} (${unassigned})`,
      value: UNASSIGNED_OPTION,
    },
  ];
};

/** Options for the row's assign control. The current folder is disabled, so it cannot be
 *  re-selected; Unassigned is not a speciality, so it keeps its own key. */
export const buildAssignOptions = (specialityNames = [], currentName = "") => [
  ...specialityNames.map((name) => ({
    value: `${SPECIALITY_MENU_PREFIX}${name}`,
    label: name,
    disabled: name === currentName,
  })),
  {
    value: UNASSIGNED_MENU_KEY,
    label: UNASSIGNED_OPTION,
    disabled: !currentName,
  },
];

/** The folder an option value stands for — "" for Unassigned, which is what gets stored. */
export const folderFromMenuKey = (key) => {
  const menuKey = String(key);
  return menuKey.startsWith(SPECIALITY_MENU_PREFIX) ? menuKey.slice(SPECIALITY_MENU_PREFIX.length) : "";
};
